import React, { useEffect, useRef } from 'react';
import anime from 'animejs';

const TextAnimation = ({ id, text, textStyle, du, de }) => {
  const textBoxRef = useRef(null);
  const hasAnimated = useRef(false); // To track if animation has run already

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true; // Mark as animated
          anime.timeline({ loop: false }) // Run the animation once
            .add({
              targets: `#${id}`, // Target the element by its ID
              translateY: ['150px', 0],
              opacity: [0, 1],
              easing: 'easeOutExpo',
              duration: du ?? 2000,
              delay: de ?? 0,
            });
        }
      },
      {
        threshold: 0.0, // Trigger animation when the element enters the viewport
      }
    );

    if (textBoxRef.current) {
      observer.observe(textBoxRef.current);
    }

    return () => observer.disconnect();
  }, [id, du, de]);

  return (
    <div
      ref={textBoxRef}
      className="text-box h-fit p-2"
      style={{
        overflowY: 'hidden',
        opacity: 1, // Initial visibility
      }}
    >
      <h1
        id={id} // Set the ID here for AnimeJS targeting
        className={`${textStyle} translate-y-[150px] opacity-0`}
      >
        {text}
      </h1>
    </div>
  );
};

export default TextAnimation;
